import React from "react";
import {
    List,
    ListItem,
} from "@material-tailwind/react";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import { FaFlask, FaIndustry, FaPills } from "react-icons/fa";

function Sidebar() {
    const location = useLocation();

    const isActive = (path) => {
        return location.pathname.startsWith(path);
    };

    return (
        <div className="h-full px-4 bg-white border-r">
            <div className="flex items-center gap-2 py-6 font-bold text-18">
                <img src="logo.svg" className="size-6" alt="logo" />
                Pharmacy Wiki
            </div>
            <List className="p-0 min-w-[200px] mb-5">
                <Link to="/ingredients">
                    <ListItem
                        className={`py-2.5 hover:bg-primary hover:text-white focus:bg-primary focus:text-white active:bg-primary active:text-white 
                        ${isActive('/ingredients') ? 'bg-primary text-white' : ''}
                    `}
                    >
                        <FaFlask className="w-5 h-5" />
                        <div className="ml-2">Ingredients</div>
                    </ListItem>
                </Link>
                <Link to="/manufacturers">
                    <ListItem
                        className={`py-2.5 hover:bg-primary hover:text-white focus:bg-primary focus:text-white active:bg-primary active:text-white 
                        ${isActive('/manufacturers') ? 'bg-primary text-white' : ''}
                    `}
                    >
                        <FaIndustry className="w-5 h-5" />
                        <div className="ml-2">Manufacturers</div>
                    </ListItem>
                </Link>
                <Link to="/tradenames">
                    <ListItem
                        className={`py-2.5 hover:bg-primary hover:text-white focus:bg-primary focus:text-white active:bg-primary active:text-white 
                        ${isActive('/tradenames') ? 'bg-primary text-white' : ''}
                    `}
                    >
                        <FaPills className="w-5 h-5" />
                        <div className="ml-2">Tradenames</div>
                    </ListItem>
                </Link>
            </List>
        </div>
    );
}

export default Sidebar;